<template>
  <div class="filelist">
    <v-card>
      <v-toolbar text dense height="45">
        <v-icon>image</v-icon>
        <v-toolbar-title>
          Select image from
          <strong>{{ filePath }}</strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click.stop="showList = !showList">
            <v-icon v-if="showList === false">expand_more</v-icon>
            <v-icon v-else>expand_less</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        hide-default-footer
        :items="fileList"
        :must-sort="true"
        class="mt-1"
        v-if="showList"
      >
        <template v-slot:item="props">
          <tr>
            <td>
              <a @click.stop="selectFile(props.item)">{{ props.item.name }}</a>
            </td>
            <td class="justify-right layout px-0">
              <v-icon class="mr-2" @click.stop="selectFile(props.item)">add_circle_outline</v-icon>
              <v-icon @click.stop="deleteFile(props.item)">delete</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>No images</template>
      </v-data-table>
      <v-footer v-if="showList">
        <v-btn text @click.stop="listFiles(lastPageToken)">Initial</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click.stop="listFiles(nextPageToken)">Show more...</v-btn>
      </v-footer>
    </v-card>
  </div>
</template>

<script>
import fb from "@/firebase";

export default {
  name: "FileSelector",
  props: {
    filePath: String
  },
  data() {
    return {
      fileList: [],
      rowsPerPage: 10,
      nextPageToken: "",
      lastPageToken: "",
      showList: false,
      headers: [
        { text: "Name", value: "name" },
        { text: "Actions", value: "actions", sortable: false, align: "center" }
      ]
    };
  },
  computed: {},
  methods: {
    listFiles(pageToken) {
      let options = { maxResults: this.rowsPerPage };

      if (pageToken) {
        options.pageToken = pageToken;
      }

      console.log(options);
      fb.storage
        .child(`${this.filePath || "public_images"}/`)
        .list(options)
        .then(snapshot => {
          console.log("items", snapshot.items);
          this.fileList = snapshot.items;
          this.nextPageToken = snapshot.nextPageToken;
        });
    },
    selectFile(ref) {
      let uploadedFile = {};

      ref.getDownloadURL().then(downloadURL => {
        uploadedFile = {
          public_url: downloadURL,
          name: ref.name,
          bucket: ref.bucket,
          path: ref.fullPath
        };
        this.$emit("input", uploadedFile);
      });
    },
    deleteFile(ref) {
      if (confirm(`The file ${ref.name} will be removed, it's that ok?`)) {
        ref.delete().then(() => this.listFiles());
      }
    }
  },
  mounted: function() {
    this.listFiles();
  },
  watch: {}
};
</script>
